import { render, staticRenderFns } from "./ContratoProveedor.vue?vue&type=template&id=44f6a119&"
import script from "./ContratoProveedor.vue?vue&type=script&lang=ts&"
export * from "./ContratoProveedor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('44f6a119', component.options)
    } else {
      api.reload('44f6a119', component.options)
    }
    module.hot.accept("./ContratoProveedor.vue?vue&type=template&id=44f6a119&", function () {
      api.rerender('44f6a119', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/ContratoProveedor/ContratoProveedor.vue"
export default component.exports